
import React from 'react';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/card';
import { ColorScheme, ExchangePlatform } from '@/types/trader';
import { RiskLevel } from '@/types/premium-bots';
import { colorSchemeStyles } from './utils/styles';
import { PremiumBotCardHeader } from './CardHeader';
import { ProfitStatsSection } from './ProfitStatsSection';
import { BotDetailsSection } from './BotDetailsSection';
import { PremiumBotCardFooter } from './CardFooter';
import { useIsMobile } from '@/hooks/use-mobile';

interface PremiumBotCardProps {
  id: string;
  name: string;
  risk: RiskLevel | string;
  riskColor: string;
  description: string;
  tradingStyle: string;
  profitShare: number;
  subscribersTotal: number;
  connectedAccountsTotal: number;
  minCapital: number;
  isIntegrated: boolean;
  isFeatured: boolean;
  isNew: boolean;
  isBestSeller: boolean;
  exchanges: ExchangePlatform[] | null;
  colorScheme?: ColorScheme;
  potentialProfit?: string;
  maxDrawdown?: string;
  onActionClick: () => void;
}

export const PremiumBotCard = ({
  id,
  name,
  risk,
  riskColor,
  description,
  tradingStyle,
  profitShare,
  subscribersTotal,
  connectedAccountsTotal,
  minCapital,
  isIntegrated,
  isFeatured,
  isNew,
  isBestSeller,
  exchanges,
  colorScheme,
  potentialProfit,
  maxDrawdown,
  onActionClick
}: PremiumBotCardProps) => {
  const cardStyle = colorScheme ? colorSchemeStyles[colorScheme] : '';
  const isMobile = useIsMobile();

  return (
    <div className={cn(
      'rounded-lg card-shine transition-all duration-300 hover:translate-y-[-2px]',
      cardStyle,
      'animate-fade-in'
    )}>
      <Card className="border-0 bg-transparent h-full flex flex-col">
        {/* Card Header Component */}
        <PremiumBotCardHeader 
          name={name}
          risk={risk}
          riskColor={riskColor}
          description={description}
          tradingStyle={tradingStyle}
          isFeatured={isFeatured}
          isNew={isNew}
          isBestSeller={isBestSeller}
          exchanges={exchanges}
          colorScheme={colorScheme}
        />
        
        {/* Profit Stats Section */}
        <ProfitStatsSection 
          potentialProfit={potentialProfit}
          maxDrawdown={maxDrawdown}
        />
        
        {/* Bot Details Section */}
        <BotDetailsSection 
          profitShare={profitShare}
          subscribersTotal={subscribersTotal}
          connectedAccountsTotal={connectedAccountsTotal}
          minCapital={minCapital}
        />
        
        {/* Card Footer */}
        <PremiumBotCardFooter 
          isIntegrated={isIntegrated}
          onActionClick={onActionClick}
        />
      </Card>
    </div>
  );
};
